import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

function ActionButtons({ row, onEdit, onDelete, t }) {
  const user = row.original;
  return (
    <>
      <MDButton
        variant="text"
        color="info"
        onClick={() => onEdit(user)}
        title={t ? t("admin.annotators.table.actions.edit", "Edit") : "Edit"}
      >
        <Icon>edit</Icon>
      </MDButton>
      <MDButton
        variant="text"
        color="error"
        onClick={() => onDelete(user)}
        title={t ? t("admin.annotators.table.actions.delete", "Delete") : "Delete"}
      >
        <Icon>delete</Icon>
      </MDButton>
    </>
  );
}

ActionButtons.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func,
};

ActionButtons.defaultProps = {
  t: null,
};

export default function UsersDataTable({ users, onEdit, onDelete, t }) {
  return {
    columns: [
      {
        Header: t ? t("admin.annotators.table.columns.actions", "Actions") : "Actions",
        accessor: "actions",
        Cell: (props) => <ActionButtons {...props} onEdit={onEdit} onDelete={onDelete} t={t} />,
      },
      {
        Header: t ? t("admin.annotators.table.columns.name", "Name") : "Name",
        accessor: "first_name",
      },
      {
        Header: t
          ? t("admin.annotators.table.columns.phoneNumber", "Phone Number")
          : "Phone Number",
        accessor: "phone_number",
      },
      {
        Header: t ? t("admin.annotators.table.columns.email", "Email") : "Email",
        accessor: "email_id",
      },
      {
        Header: t ? t("admin.annotators.table.columns.country", "Country") : "Country",
        accessor: "country",
      },
      {
        Header: t ? t("admin.annotators.table.columns.district", "IEF") : "IEF",
        accessor: "district",
      },
      {
        Header: t
          ? t("admin.annotators.table.columns.programName", "Program Name")
          : "Program Name",
        accessor: "program_name",
      },
      {
        Header: t ? t("admin.annotators.table.columns.samples", "Samples") : "Samples",
        accessor: "assigned_samples",
        Cell: ({ value }) => value || "0",
      },
      {
        Header: t ? t("admin.annotators.table.columns.created_by", "Created By") : "Created By",
        accessor: "created_by",
      },
    ],
    rows: users.map((user) => ({
      ...user,
      actions: "", // optional if you're not using it directly
    })),
  };
}

UsersDataTable.propTypes = {
  users: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func,
};

UsersDataTable.defaultProps = {
  t: null,
};
